import React from 'react';
import { Page, Text, Document, StyleSheet, View } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 30
  },
  title: {
    fontSize: 18,
    marginBottom: 10,
    textAlign: 'center'
  },
  content: {
    fontSize: 12,
    textAlign: 'justify',
    marginBottom: 15
  },
  section: {
    marginTop: 10
  },
  sectionText: {
    fontSize: 10,
    textAlign: 'justify',
    marginBottom: 8
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 10,
    bottom: 20,
    right: 20,
    textAlign: 'right'
  }
});

const formatParagraphs = (paragraphs) => {
  return paragraphs.map((item, index) => `${index + 1}. ${item}`);
};

const generateContent = (paragraphs) => {
  return paragraphs.map((item, index) =>
    item.trim() ? (
      item.split('\n').map((line, lineIndex) => (
        <React.Fragment key={`${index}-${lineIndex}`}>
          {line}
          <br />
        </React.Fragment>
      ))
    ) : (
      <React.Fragment key={`blank-${index}`}>
        <br />
      </React.Fragment>
    )
  );
};

const MyDocument = ({ title, content, paragraphs, isFaithOfAmendment }) => {
  const formattedParagraphs = isFaithOfAmendment
    ? generateContent(paragraphs)
    : formatParagraphs(paragraphs);

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.content}>{content}</Text>
        <View style={styles.section}>
          {formattedParagraphs.map((line, idx) => (
            <Text style={styles.sectionText} key={idx}>
              {line}
            </Text>
          ))}
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
          fixed
        />
      </Page>
    </Document>
  );
};

export default MyDocument;
